import type { Relatorio } from '@modules/ifc-edit/lib/operacoesEmMassa'
import { AVISO, NOTA, OK } from './estilos'
import { explicarPorque } from './simular'

function descreverOperacao(o: Relatorio['ignoradas'][number]['operacao']): string {
  switch (o.tipo) {
    case 'definir':
      return `${o.guid} ${o.pset}.${o.propriedade} = ${o.valor}`
    case 'renomear-pset':
      return `renomear ${o.de} para ${o.para}`
    case 'renomear-propriedade':
      return `renomear ${o.pset}.${o.de} para ${o.para}`
    case 'apagar-pset':
      return `apagar ${o.nome}`
    case 'apagar-propriedade':
      return `apagar ${o.pset}.${o.nome}`
    case 'material':
      return `${o.guid} material = ${o.material}`
    case 'classificar':
      return `${o.guid} ${o.sistema} = ${o.codigo}`
  }
}

/** O relatório de uma simulação ou de uma gravação. */
export default function RelatorioDeOperacoes({ r }: { r: Relatorio }) {
  const partes = [
    r.psetsCriados && `${r.psetsCriados} Pset(s) novo(s)`,
    r.propriedadesCriadas && `${r.propriedadesCriadas} propriedade(s) nova(s)`,
    r.valoresAlterados && `${r.valoresAlterados} valor(es) alterado(s)`,
    r.copiasDePartilhados && `${r.copiasDePartilhados} cópia(s) de Psets partilhados`,
    r.renomeados && `${r.renomeados} nome(s) mudado(s)`,
    r.entidadesApagadas && `${r.entidadesApagadas} entidade(s) apagada(s)`,
    r.materiaisAlterados && `${r.materiaisAlterados} material(is) mudado(s)`,
    r.classificacoesAlteradas && `${r.classificacoesAlteradas} classificação(ões) mudada(s)`,
  ].filter(Boolean)
  return (
    <div className="flex flex-col gap-1">
      <div className={r.ignoradas.length === 0 ? OK : AVISO}>
        {r.aplicadas} operaç{r.aplicadas === 1 ? 'ão aplicada' : 'ões aplicadas'}
        {partes.length > 0 && `: ${partes.join(', ')}`}
        {r.ignoradas.length > 0 && `. ${r.ignoradas.length} ignorada(s).`}
      </div>
      {r.copiasDePartilhados > 0 && (
        <p className={NOTA}>
          Um Pset partilhado por vários elementos é copiado antes de mudar só alguns deles: assim os outros ficam
          como estavam.
        </p>
      )}
      {r.tipos.length > 0 && (
        <details className="text-[10px]">
          <summary className="cursor-pointer text-[var(--color-text-muted)]">Tipo de valor de cada propriedade, e porquê</summary>
          <ul className="mt-1 flex flex-col gap-0.5 pl-3">
            {r.tipos.map((t) => (
              <li key={`${t.pset}.${t.propriedade}.${t.tipo}.${t.porque}`}>
                <span className="font-mono">{t.pset}.{t.propriedade}</span>: <span className="font-mono">{t.tipo}</span>,{' '}
                {explicarPorque(t.porque)}
              </li>
            ))}
          </ul>
        </details>
      )}
      {r.avisos.map((a) => (
        <div key={a} className={AVISO}>{a}</div>
      ))}
      {r.ignoradas.length > 0 && (
        <details className="text-[10px]" open={r.ignoradas.length <= 5}>
          <summary className="cursor-pointer text-[var(--color-warn-text)]">Ignoradas ({r.ignoradas.length})</summary>
          <ul className="mt-1 flex max-h-40 flex-col gap-0.5 overflow-auto pl-3">
            {r.ignoradas.slice(0, 200).map((i, n) => (
              <li key={n}>
                <span className="font-mono text-[var(--color-text-muted)]">{descreverOperacao(i.operacao)}</span>: {i.motivo}
              </li>
            ))}
          </ul>
        </details>
      )}
    </div>
  )
}
